<template>
  <div class="empty-folder">
    <div>
      <div class="img-wrap">
        <img src="./../../assets/images/empty-folder.png" />
      </div>
      <h1>{{ title }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "No content available",
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-folder {
  margin-top: 100px;

  .img-wrap {

    display: flex;
    justify-content: center;

  }
  img {
    width: 70px;
    opacity: 0.5;
  };
  h1 {
    color: #777;
    text-align: center;
    font-size: 19px;
  }

 
}
</style>